module.exports = __webpack_public_path__ + "static/img/aepic-14.dd168f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-14.jpg
// module id = zuPd
// module chunks = 51